import { Context, Effect, Layer } from 'effect';
import Papa from 'papaparse';
export const Csv = Context.GenericTag('@services/Csv');
export const layer = Layer.effect(Csv, Effect.sync(() => {
    const parseFromFile = (file) => Effect.tryPromise({
        try: () => {
            return new Promise(res => {
                Papa.parse(file, { header: true, complete: x => res(x) });
            });
        },
        catch: e => {
            if (e instanceof Error)
                return e;
            return new Error('Unknown error: ' + JSON.stringify(e));
        },
    });
    const toCsv = (data, columns) => {
        const csvString = Papa.unparse(data, { columns: columns ?? undefined });
        return new Blob([csvString], { type: 'text/csv' });
    };
    return { parseFromFile, toCsv };
}));
